/* LAVISH Hero – Slideshow (Bild 2+ erst nach dem Seitenladen, jeweils kurz vor dem Wechsel) + Video-Hintergrund (immer stumm,
   optional nur ein Ausschnitt: Start + Laenge, als Schleife).
   Nie bei Datensparmodus/2G: dann bleibt Bild 1 bzw. das Standbild stehen. */
(function () {
  if (window.__lvhJS) return;
  window.__lvhJS = true;
  var c = navigator.connection || {};
  var slow = !!(c.saveData || /(^|-)2g$/.test(c.effectiveType || ''));
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (slow || !root || root.__lvh) return;
    var slides = [].slice.call(root.querySelectorAll('[data-lvh-slide]'));
    if (slides.length < 2) return;
    root.__lvh = true;
    var dots = [].slice.call(root.querySelectorAll('[data-lvh-dot]'));
    var ms = (parseInt(root.getAttribute('data-lvh-rotate'), 10) || 5) * 1000;
    var cur = 0, timer = null, pre = null, visible = true;
    var LEAD = 2500; /* nächstes Bild so viele ms vor dem Wechsel laden */

    function load(s) {
      if (s.__p) return s.__p;
      [].forEach.call(s.querySelectorAll('[data-srcset]'), function (e) {
        e.srcset = e.getAttribute('data-srcset');
        e.removeAttribute('data-srcset');
      });
      var img = s.querySelector('img');
      s.__p = new Promise(function (res) {
        if (img.complete && img.naturalWidth) return res();
        img.onload = img.onerror = function () { res(); };
      });
      return s.__p;
    }

    function show(n) {
      n = (n + slides.length) % slides.length;
      var s = slides[n];
      return load(s).then(function () {
        if (!s.querySelector('img').naturalWidth) return; /* Bild kaputt → überspringen */
        slides[cur].classList.remove('is-active');
        s.classList.add('is-active');
        if (dots[cur]) dots[cur].classList.remove('is-active');
        if (dots[n]) dots[n].classList.add('is-active');
        cur = n;
      });
    }

    function tick() {
      clearTimeout(timer);
      clearTimeout(pre);
      if (reduce || !visible || document.hidden) return;
      /* nächstes Bild erst kurz vor dem Wechsel holen, nicht schon beim Seitenstart */
      pre = setTimeout(function () { load(slides[(cur + 1) % slides.length]); }, Math.max(0, ms - LEAD));
      timer = setTimeout(function () { show(cur + 1).then(tick); }, ms);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-lvh-dot'), 10)).then(tick);
      });
    });
    if (dots.length) dots[0].parentNode.hidden = false;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        tick();
      }).observe(root);
    }
    document.addEventListener('visibilitychange', tick);

    tick();
  }

  /* Video: Quelle erst setzen, wenn es losgehen soll (Handy max. 720p, Desktop max. 1080p – im Liquid gewählt).
     Läuft nur, solange der Hero sichtbar ist und der Tab aktiv ist. */
  function initVideo(v) {
    var root = v.closest('.lvh');
    if (!root || v.__lvv) return;
    v.__lvv = true;
    if (slow) return; /* nur Standbild, Buttons bleiben versteckt */
    /* immer stumm: kein Ton-Button, auch per Tastatur/Medientasten nicht laut */
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
    var ctl = root.querySelector('[data-lvv-ctl]');
    var bp = root.querySelector('[data-lvv-pause]');
    var mq = window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false };
    var userPaused = !!reduce; /* Bewegung reduzieren: startet nicht von selbst */
    var visible = !('IntersectionObserver' in window);

    /* Ausschnitt („Start bei“ / „Länge der Schleife“): das Liquid haengt bei Start > 0 ein Media-Fragment #t=start an die URL
       (Browser springt direkt dorthin, Range-Request) und schreibt die Laenge in data-lvv-len. Natives loop wuerde bei 0 neu
       beginnen – deshalb wiederholt hier das JS selbst: kurz vor Start + Laenge (bzw. Videoende) zurueck zum Start. */
    var seg = null;
    var segLen = parseFloat(v.getAttribute('data-lvv-len')) || 0;
    function parseSeg(u) {
      var m = /#t=(\d+(?:\.\d+)?)/.exec(u || '');
      var a = m ? +m[1] : 0;
      return (a > 0 || segLen > 0) ? { s: a, l: segLen } : null;
    }
    function segEnd() {
      var d = v.duration, e = seg.l ? seg.s + seg.l : 0;
      if (isFinite(d) && d > 0) e = e ? Math.min(e, d) : d;
      return e || Infinity;
    }
    function toStart() {
      try { v.currentTime = seg.s; } catch (x) {}
    }
    /* lead = wie viele Sekunden vor dem Ende zurueckgesprungen wird (pro Bild ~0,07 s, sonst timeupdate-Takt ~0,3 s) */
    function check(lead) {
      if (!seg || v.seeking) return;
      if (v.currentTime >= segEnd() - lead) toStart();
    }
    var rvfc = !!v.requestVideoFrameCallback;
    if (rvfc) {
      var onFrame = function () { check(0.07); v.requestVideoFrameCallback(onFrame); };
      v.requestVideoFrameCallback(onFrame);
    }
    v.addEventListener('timeupdate', function () { check(rvfc ? 0.02 : 0.3); });
    v.addEventListener('loadedmetadata', function () {
      if (!seg) return;
      var d = v.duration;
      /* ungueltig (Start hinter dem Ende) -> ab 0; Ende hinter dem Videoende -> segEnd() nimmt das Videoende */
      if (isFinite(d) && d > 0 && seg.s >= d - 0.5) { seg.s = 0; toStart(); }
      if (v.currentTime < seg.s - 0.2) toStart(); /* Browser ohne Media-Fragment-Support */
    });
    function wantsPlay() { return visible && !document.hidden && !userPaused; }
    /* Fallback: Video ist doch bis zum Ende gelaufen (z. B. Tab gedrosselt) -> wieder ab Start */
    function restart() {
      if (!seg) return;
      toStart();
      if (wantsPlay()) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    }
    v.addEventListener('ended', restart);
    v.addEventListener('pause', function () {
      if (seg && wantsPlay() && v.currentTime >= segEnd() - 0.35) restart();
    });

    function url() {
      var d = v.getAttribute('data-lvv-d'), m = v.getAttribute('data-lvv-m');
      return (mq.matches ? (m || d) : (d || m)) || '';
    }
    function ensureSrc() {
      var u = url();
      if (u && v.getAttribute('src') !== u) {
        seg = parseSeg(u);
        v.loop = !seg;
        v.classList.remove('is-on');
        v.setAttribute('src', u);
      }
    }
    function pausedUI(p) {
      root.classList.toggle('is-paused', p);
      if (bp) bp.setAttribute('aria-label', bp.getAttribute(p ? 'data-l-play' : 'data-l-pause'));
    }

    /* iPhone blockiert Autoplay manchmal (Stromsparmodus, manche In-App-Browser): dann bleibt das Bild stehen und das
       Video startet bei der ersten Beruehrung/dem ersten Klick irgendwo auf der Seite (nur so erlaubt iOS den Start). */
    var armed = false, EV = ['touchend', 'click', 'keydown'];
    function onGesture() {
      EV.forEach(function (e) { document.removeEventListener(e, onGesture, true); });
      armed = false;
      if (!v.paused) return;
      ensureSrc();
      var pr = v.play(); /* direkt in der Geste starten, auch wenn der Hero gerade nicht sichtbar ist */
      if (pr && pr.then) pr.then(function () { if (!wantsPlay()) v.pause(); }, function () {});
    }
    function armGesture() {
      if (armed) return;
      armed = true;
      EV.forEach(function (e) { document.addEventListener(e, onGesture, { capture: true, passive: true }); });
    }

    function update() {
      if (wantsPlay()) {
        ensureSrc();
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {
          if (!v.paused) return;
          if (bp) { userPaused = true; pausedUI(true); } /* mit Pause-Button: Play-Button bietet Start an */
          armGesture();
        });
      } else if (!v.paused) {
        v.pause();
      }
    }

    v.addEventListener('playing', function () { v.classList.add('is-on'); });
    v.addEventListener('error', function () {
      v.classList.remove('is-on');
      if (ctl) ctl.hidden = true;
    });

    if (bp) bp.addEventListener('click', function () {
      userPaused = !userPaused;
      pausedUI(userPaused);
      update();
    });

    pausedUI(userPaused);
    if (ctl) ctl.hidden = false;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        update();
      }, { threshold: 0.05 }).observe(root);
    }
    document.addEventListener('visibilitychange', update);
    var onBp = function () { if (v.getAttribute('src')) update(); };
    if (mq.addEventListener) mq.addEventListener('change', onBp);
    else if (mq.addListener) mq.addListener(onBp);
    update();
  }

  function run() {
    [].forEach.call(document.querySelectorAll('[data-lvh-rotate]'), init);
    [].forEach.call(document.querySelectorAll('.lvh [data-lvv]'), initVideo);
  }
  function later() {
    /* nach dem Seitenladen in einer Leerlaufphase starten – spaetestens nach 1,5 s (rIC kann auf vollen Seiten sonst ewig warten) */
    if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 1500 });
    else setTimeout(run, 200);
  }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later);
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 50); });
})();
